import { render } from "./LoadingIcon.vue?vue&type=template&id=64951292"
const script = {}
script.render = render

export default script